module.exports = __webpack_public_path__ + "static/fire-blanket-1-8a9806b572723c6e62cd4008d7a9919d.png";